import React from 'react';
import PropTypes from 'prop-types';

function AlignEndHorizontal({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M16.8665 16.6667V3.33334M4.86654 4.66667H12.8665C13.6029 4.66667 14.1999 5.26362 14.1999 6V7.33334C14.1999 8.06972 13.6029 8.66667 12.8665 8.66667H4.86654C4.13016 8.66667 3.5332 8.06972 3.5332 7.33334V6C3.5332 5.26362 4.13016 4.66667 4.86654 4.66667ZM9.5332 11.3333H12.8665C13.6029 11.3333 14.1999 11.9303 14.1999 12.6667V14C14.1999 14.7364 13.6029 15.3333 12.8665 15.3333H9.5332C8.79682 15.3333 8.19987 14.7364 8.19987 14V12.6667C8.19987 11.9303 8.79682 11.3333 9.5332 11.3333Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

AlignEndHorizontal.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default AlignEndHorizontal;
